import { render, staticRenderFns } from "./EmarticonList.vue?vue&type=template&id=b1070d24&scoped=true"
import script from "./EmarticonList.vue?vue&type=script&lang=js"
export * from "./EmarticonList.vue?vue&type=script&lang=js"
import style0 from "./EmarticonList.vue?vue&type=style&index=0&id=b1070d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1070d24",
  null
  
)

export default component.exports